import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { API_BASE } from '../../../config';

export default function useClientSuggestions({ setForm }) {
  const [clientSuggestions, setClientSuggestions] = useState([]);
  const [showClientSuggestions, setShowClientSuggestions] = useState(false);
  const [suggestionsPos, setSuggestionsPos] = useState(null);
  // KLI-03: podpowiedzi mogą wychodzić z pola nazwiska LUB z pola e-mail — anchorField
  // decyduje, pod którym polem pozycjonujemy listę (i jest w zależnościach efektu
  // pozycji, żeby przełączenie pola przesunęło dropdown nawet gdy już jest otwarty).
  const [anchorField, setAnchorField] = useState('lastname');
  const lastnameWrapperRef = useRef(null);
  const emailWrapperRef = useRef(null);
  const suggestionRef = useRef(null);
  const suggestionsListRef = useRef(null);

  const fetchClientSuggestions = async (q) => {
    if (!q || q.length < 2) {
      setClientSuggestions([]);
      setShowClientSuggestions(false);
      return;
    }
    try {
      const res = await axios.get(
        `${API_BASE}/api/clients/search?query=${encodeURIComponent(q)}`,
        { withCredentials: true }
      );
      setClientSuggestions(res.data || []);
      setShowClientSuggestions((res.data || []).length > 0);
    } catch {
      setClientSuggestions([]);
      setShowClientSuggestions(false);
    }
  };

  const handleLastnameChange = (e) => {
    const value = e.target.value;
    setForm(prev => ({ ...prev, lastName: value }));
    if (value && value.length >= 2) {
      setAnchorField('lastname');
      fetchClientSuggestions(value);
    } else {
      setClientSuggestions([]);
      setShowClientSuggestions(false);
    }
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setForm(prev => ({ ...prev, email: value }));
    if (value && value.length >= 2) {
      setAnchorField('email');
      fetchClientSuggestions(value);
    } else {
      setClientSuggestions([]);
      setShowClientSuggestions(false);
    }
  };

  const handleClientSuggestionClick = (client) => {
    setForm(prev => ({
      ...prev,
      firstName: client.firstname || prev.firstName || '',
      lastName: client.lastname || prev.lastName || '',
      email: client.email || prev.email || ''
    }));
    setClientSuggestions([]);
    setShowClientSuggestions(false);
  };

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (
        (suggestionRef.current && suggestionRef.current.contains(e.target)) ||
        (emailWrapperRef.current && emailWrapperRef.current.contains(e.target)) ||
        (suggestionsListRef.current && suggestionsListRef.current.contains(e.target))
      ) {
        return;
      }
      setShowClientSuggestions(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  // Update suggestions dropdown position (anchored to the field that opened it)
  useEffect(() => {
    if (!showClientSuggestions) return;
    const update = () => {
      const anchor = anchorField === 'email'
        ? emailWrapperRef.current
        : lastnameWrapperRef.current;
      if (!anchor) return;
      const rect = anchor.getBoundingClientRect();
      setSuggestionsPos({
        top: rect.bottom + window.scrollY + 6,
        left: rect.left + window.scrollX,
        width: rect.width
      });
    };
    update();
    window.addEventListener('resize', update);
    window.addEventListener('scroll', update, true);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('scroll', update, true);
    };
  }, [showClientSuggestions, anchorField]);

  return {
    clientSuggestions,
    showClientSuggestions,
    suggestionsPos,
    lastnameWrapperRef,
    emailWrapperRef,
    suggestionRef,
    suggestionsListRef,
    handleLastnameChange,
    handleEmailChange,
    handleClientSuggestionClick,
  };
}
